import { ComponentRef } from '@angular/core';

export enum HomeFeedSection {
  FINDMONEY = 'FIND_MONEY',
  MYMONEYINFO = 'MYMONEYINFO',
  MYMONEYCOMPLETE = 'MY_MONEY_COMPLETE',
  MYMONEYINITIAL = 'MY_MONEY_INITIAL',
  MYMONEYHELP = 'MY_MONEY_HELP',
  ACTIONS = 'ACTIONS',
  PROMOTION = 'PROMOTION',
  PROGRAMS = 'PROGRAMS',
  PAYDAY = 'PAYDAY',
  REPAYMENTS = 'REPAYMENTS',
  URGENT_NOTIFICATIONS = 'URGENT_NOTIFICATIONS',
}

export interface HomeFeedCard {
  key: string;
  component: string; // Component name as a string
  data?: any;
  order: number;
}

export interface HomeFeedCardRegister  extends HomeFeedCard {
  componentRef: any;
  section: HomeFeedSection;
}

export interface HomeFeedState {
  sections: { [section in HomeFeedSection]: HomeFeedCard[] };
  components: { [key: string]: string }; // Stores dynamically registered component names
}
